import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import styles from './assignModal.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { Close } from '../../Svg';
import { changeAccountUserPassword } from '../../Website/redux/AccountUserSlice';

const PasswordModal = ({ isOpen, onClose, selectedId }) => {
    const {loading} = useSelector((state)=>state.accountUser)

    const [visiblePass, setVisiblePass] = useState({
        currentPassVisible: false,
        passwordVisible: false,
        confirmPassVisible: false,
    });

    const dispatch = useDispatch()

    const toggleVisibility = (field) => {
        setVisiblePass((prevState) => ({
            ...prevState,
            [field]: !prevState[field],
        }));
    };

    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
    } = useFormik({
        initialValues: {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
        },
        validationSchema: Yup.object({
            currentPassword: Yup.string().required('Current password is required'),
            newPassword: Yup.string()
                .required('New password is required')
                .min(6, 'Password must be at least 6 characters long'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
                .required('Confirm password is required'),
        }),
        onSubmit: async(values) => {
            const data = {
                id: selectedId,
                values
            }
            const status =await dispatch(changeAccountUserPassword(data))

            if (status?.payload == 200) {
                onClose()
            }
            console.log(values);
        },
    });


    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className={styles.modalHeader}>
                        <h2>Change Password</h2>
                    </div>
                    <button onClick={onClose} className={styles.closeButton} style={{cursor:'pointer'}}>
                        <Close onClick={onClose} />
                    </button>
                </div>
                <form onSubmit={handleSubmit} className={styles.modalContentDetails}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label className={styles.addCatLabel}>
                            Current Password*
                            <div className={styles.logininputContainer}>
                                <input
                                    type={visiblePass.currentPassVisible ? 'text' : 'password'}
                                    name="currentPassword"
                                    placeholder="Enter current password"
                                    className={styles.addCatInput}
                                    value={values.currentPassword}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <FontAwesomeIcon
                                    icon={visiblePass.currentPassVisible ? faEyeSlash : faEye}
                                    className={styles.loginpasswordIcon}
                                    onClick={() => toggleVisibility('currentPassVisible')}
                                />
                            </div>
                            {touched.currentPassword && errors.currentPassword && (
                                <div className={styles.error}>{errors.currentPassword}</div>
                            )}
                        </label>
                        <label className={styles.addCatLabel}>
                            New Password*
                            <div className={styles.logininputContainer}>
                                <input
                                    type={visiblePass.passwordVisible ? 'text' : 'password'}
                                    name="newPassword"
                                    placeholder="Enter new password"
                                    className={styles.addCatInput}
                                    value={values.newPassword}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <FontAwesomeIcon
                                    icon={visiblePass.passwordVisible ? faEyeSlash : faEye}
                                    className={styles.loginpasswordIcon}
                                    onClick={() => toggleVisibility('passwordVisible')}
                                />
                            </div>
                            {touched.newPassword && errors.newPassword && (
                                <div className={styles.error}>{errors.newPassword}</div>
                            )}
                        </label>
                        <label className={styles.addCatLabel}>
                            Confirm Password*
                            <div className={styles.logininputContainer}>
                                <input
                                    type={visiblePass.confirmPassVisible ? 'text' : 'password'}
                                    name="confirmPassword"
                                    placeholder="Confirm password"
                                    className={styles.addCatInput}
                                    value={values.confirmPassword}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <FontAwesomeIcon
                                    icon={visiblePass.confirmPassVisible ? faEyeSlash : faEye}
                                    className={styles.loginpasswordIcon}
                                    onClick={() => toggleVisibility('confirmPassVisible')}
                                />
                            </div>
                            {touched.confirmPassword && errors.confirmPassword && (
                                <div className={styles.error}>{errors.confirmPassword}</div>
                            )}
                        </label>
                    </div>
                    <div className={styles.modalFooter}>
                        <button type="button" onClick={onClose} className={styles.cancelButton}>
                            Cancel
                        </button>
                        <button type="submit" className={styles.deleteButton} disabled={loading}>
                            {loading ? 'Please wait...' :  'Update'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PasswordModal;
